<script lang="ts">
    import {Link} from 'svelte-routing'
    import EmptyLayout from "../#common/layout/Empty.svelte"
</script>

<svelte:head>
    <title>404 | Page not found</title>
    <meta name='robots' content='noindex, follow'/>
</svelte:head>

<EmptyLayout>
    <svelte:fragment slot="content">
        <section class="main-intro">
            <div class="container">
                <div class="wrapper-404">
                    <h1>404</h1>
                    <p>Page not found</p>
                    <Link to="/" class="btn btn-primary">Go Dashboard</Link>
                </div>
            </div>
        </section>
    </svelte:fragment>
</EmptyLayout>

<style>
    .main-intro {
        padding: 210px 0 150px;
    }

    .wrapper-404 {
        margin: 0 auto;
        text-align: center;
        font-size: 20px;
        color: white;
    }

    h1 {
        font-size: 70px;
    }

    @media (max-width: 767px) {
        h1 {
            font-size: 50px;
        }

        .wrapper-404 {
            font-size: 18px;
        }
    }
</style>
